import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (id) => {
    setOpen(false);

    if (location.pathname !== "/") {
      // Navigate to home page with hash for the section
      navigate(`/#${id}`);
    } else {
      // If already on home, scroll directly
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <header className="navbar">
      <div className="navbar-content">
        {/* Logo */}
        <div className="logo-area">
          <img src="/logo1.jpg" alt="Logo" className="logo-img" />
        </div>

        {/* Donate Button */}
        <button
          className="donate-btn"
          onClick={() => {
            navigate("/payment");
            setOpen(false);
          }}
        >
          ❤️ Donate
        </button>

        {/* Nav Links */}
        <nav className={`nav-links ${open ? "show" : ""}`}>
          <button onClick={() => handleNavClick("home")}>Home</button>
          <button onClick={() => handleNavClick("about")}>About</button>
          <button onClick={() => handleNavClick("articles")}>Our Objectives</button>
          <button onClick={() => handleNavClick("certificates")}>Certificates</button>
          <button onClick={() => handleNavClick("register")}>Register</button>
          <button onClick={() => handleNavClick("gallery")}>Our Services</button>
          <button onClick={() => handleNavClick("custom-gallery")}>Our Gallery</button>
          <button onClick={() => handleNavClick("video")}>Videos</button>
          <button onClick={() => handleNavClick("contact")}>Contact</button>
        </nav>

        {/* Hamburger */}
        <div className="hamburger" onClick={() => setOpen(!open)}>
          <span className={`bar ${open ? "rotate-top" : ""}`}></span>
          <span className={`bar ${open ? "hide" : ""}`}></span>
          <span className={`bar ${open ? "rotate-bottom" : ""}`}></span>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
